


import { AppFullscreen } from 'quasar'
import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'LayoutDefault',

  components: {
    HelloWorld
  },

  data () {
    return {
      leftDrawerOpen: false,
      text:'',
      dense : true,
    }
  },
  methods: {

    logout : function(){
      localStorage.removeItem('token');
      localStorage.removeItem('profile');
      this.$router.push('/login');
    },

    cekToken(){
      fetch(this.$store.state.url.URL_LOGIN + "dinkes_auth", {
          method: "GET",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          }
      })
          .then(res => res.json())
          .then(res_data => {
            // console.log(res_data)
              if (res_data.message == 'Tidak ter-Authorisasi') {
                localStorage.removeItem("token");
                localStorage.removeItem("profile");
                this.$router.push("/login");
              }
      });
    },

  },
  computed: {
      checkLogin() {
          if (this.$route.name === 'login') {
              return true;
          } else {
              return false;
          }
      }
  },

  mounted () {
    this.cekToken();

  },
}
